var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 7.22266,
    width: 6.70317,
    height: 25.5552,
    rx: 3.35159,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.293,
    y: 13.0305,
    width: 5.80799,
    height: 27.483,
    rx: 2.904,
    transform: "rotate(-90 12.293 13.0305)",
    fill: "url(#paint0_linear_984_26579)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.293,
    y: 13.0305,
    width: 5.80799,
    height: 20.1095,
    rx: 2.904,
    transform: "rotate(-90 12.293 13.0305)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.293,
    y: 32.7778,
    width: 5.80799,
    height: 27.483,
    rx: 2.904,
    transform: "rotate(-90 12.293 32.7778)",
    fill: "url(#paint1_linear_984_26579)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.293,
    y: 32.7778,
    width: 5.80799,
    height: 20.1095,
    rx: 2.904,
    transform: "rotate(-90 12.293 32.7778)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.293,
    y: 22.9041,
    width: 5.80799,
    height: 27.483,
    rx: 2.904,
    transform: "rotate(-90 12.293 22.9041)",
    fill: "url(#paint2_linear_984_26579)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.293,
    y: 22.9041,
    width: 5.80799,
    height: 14.747,
    rx: 2.904,
    transform: "rotate(-90 12.293 22.9041)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_26579",
    x1: 15.197,
    y1: 13.0305,
    x2: 15.197,
    y2: 40.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357066,
    stopColor: "#115E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575008,
    stopColor: "#0F6E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795244,
    stopColor: "#0B943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA63E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_26579",
    x1: 15.197,
    y1: 32.7778,
    x2: 15.197,
    y2: 60.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357066,
    stopColor: "#115E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575008,
    stopColor: "#0F6E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#0B943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA63E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_984_26579",
    x1: 15.197,
    y1: 22.9041,
    x2: 15.197,
    y2: 50.3871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357066,
    stopColor: "#115E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575008,
    stopColor: "#0F6E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#0B943D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA63E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogo);
export default __webpack_public_path__ + "static/media/logo-logo.37ac6bb7c60891e79830152a0e23c71a.svg";
export { ForwardRef as ReactComponent };